import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import type { Hotel, Market, Reportgroup } from 'frontend-utils/models';
import registerObserver from 'frontend-utils/utils/register-observer';
import type { permissionChecks } from 'lumen/utils/permissions';

interface CanSignature {
  Args: {
    Positional: [
      keyof typeof permissionChecks,
      (Hotel | Market | Reportgroup | undefined)?,
    ];
  };
  Return: boolean;
}

export default class CanHelper extends Helper<CanSignature> {
  @service declare access: Services['access'];

  constructor() {
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);

    registerObserver(
      this,
      ['access.hotel', 'access.market'],
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.onHotelChange,
    );
  }

  compute(args: CanSignature['Args']['Positional']): CanSignature['Return'] {
    const permission = args[0];
    const resource = args.length > 1 ? args[1] : undefined; // Optional resource argument

    return this.access.can(permission, resource);
  }

  onHotelChange(): void {
    this.recompute();
  }
}
